export const ItemTypes = {
  FREECEEL: 'FREECEEL'
}
